import { jsx as a } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import i from "classnames";
const d = ({ className: r, alt: e, url: c }) => /* @__PURE__ */ a("div", { className: "adyen-pe-data-grid__icon-container", children: /* @__PURE__ */ a("img", { className: i("adyen-pe-data-grid__icon", r), alt: e, src: c }) });
export {
  d as default
};
